import React, { Component } from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import Donation from '../components/Donation'
import { setUserDonation } from '../actions/donations';
import Translation from "../../../../shared/Translation";

class DonationContainer extends Component {
    render() {
        if (!this.props.hasDonations || !Object.keys(this.props.donationOrganizations).length) {
            return null;
        }

      const donationTitle = this.props.donationTitle ? this.props.donationTitle : <Translation>{"checkout__make_a_donation"}</Translation>;
        const donationInputs = Object.keys(this.props.donationOrganizations).map(key => {
            return <Donation
                key={key}
                organization={this.props.donationOrganizations[key]}
                onChange={this.props.donationOrganizations[key].fixed ? this.onChangeFixed : this.onChange}
                value={this.props.userDonations[this.props.donationOrganizations[key].event_id]}
            />
        });

        return(
            <section className="checkout-form__section">
                <div className="form-card">
                    <div className="form-card__header">
                        <h4 className="form-card__heading">
                            {donationTitle}
                        </h4>
                    </div>
                    <div className="form-card__content">
                        {donationInputs}
                    </div>
                </div>
            </section>
        )
    }

    //change event for user supplied donation amount (text input)
    onChange = (eventId, e) => {
        this.props.setUserDonation(eventId, +e.target.value);
    }

    //change event for fixed donation amount (checkbox input)
    onChangeFixed = (eventId) => {
        const value = this.props.userDonations[eventId] === 0 ? 1 : 0;
        this.props.setUserDonation(eventId, value);
    }
}

const mapStateToProps = state => {
    return {
        hasDonations: state.donations.hasDonations,
        donationTitle: state.donations.donationTitle,
        donationOrganizations: state.donations.donationOrganizations,
        userDonations: state.donations.userDonations,
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        setUserDonation,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(DonationContainer)
